import { AngularFireAuth } from 'angularfire2/auth';
import { AngularFireDatabaseModule } from 'angularfire2/database';
import { Injectable } from '@angular/core';

import{User}from "./user.model";
import{AngularFireDatabase, AngularFireList}from "angularfire2/database";

@Injectable({
  providedIn: 'root'
})
export class UserService {
  userList:AngularFireList<any>;
  selectedUser:User = new User();
  constructor(private firebase:AngularFireDatabase) { }

getData(start:string,end:string){
  this.userList = this.firebase.list("users", 
  ref => ref.orderByChild('name').startAt(start).endAt(end)
);
  return this.userList;
}


insertUser(user:User){
  this.userList.push(user);
}


updateUser(user:User){
  this.userList.update(user.$key, user);
}

deleteUser($key:string){
this.userList.remove($key);
}

}
